module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_implant-f8b864ef217a65dc981def0595b834ff.png";